import { Observable } from "rxjs";

import * as http from "../../../services/http.service";
import { TExecutionBriefResults } from "../../../redux/reducers/executionBriefsReducer";

import { IDuplicateExecutionBriefForm } from "../types/duplicate-execution-brief-form.interface";

export function duplicate(form: IDuplicateExecutionBriefForm): Observable<TExecutionBriefResults> {
  return http.post<TExecutionBriefResults>("/execution-briefs/clone/", form);
}

export function exportBriefEndpoint(briefId: number): string {
  return `/execution-briefs/${briefId}/export/`;
}
